import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DragDropDirective } from "./drag-drop.directive";
import { UploadFileComponent } from "./upload-file/upload-file.component";
import { MaterialModule } from "./material.module";
import { HomeComponent } from "./home/home.component";
//
import { AngularFireModule } from "@angular/fire";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { AngularFireAuthModule } from "@angular/fire/auth";
import {
  AngularFireFunctionsModule,
  FunctionsRegionToken
} from "@angular/fire/functions"; // for functions
import { environment } from "src/environments/environment";

@NgModule({
  declarations: [
    AppComponent,
    DragDropDirective,
    UploadFileComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule, // firestore
    AngularFireAuthModule, // auth
    AngularFireStorageModule, // storage
    AngularFireFunctionsModule
  ],
  providers: [{ provide: FunctionsRegionToken, useValue: "us-central1" }],
  bootstrap: [AppComponent]
})
export class AppModule {}
